"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.officeAddinProjectTypeNode = exports.wxpAddinProjectTypeNode = exports.outlookAddinProjectTypeNode = void 0;
const featureFlags_1 = require("../../../common/featureFlags");
const localizeUtils_1 = require("../../../common/localizeUtils");
const questionNames_1 = require("../../questionNames");
const CapabilityOptions_1 = require("./CapabilityOptions");
const ProjectTypeOptions_1 = require("./ProjectTypeOptions");
function outlookAddinProjectTypeNode() {
    return {
        condition: {
            equals: ProjectTypeOptions_1.ProjectTypeOptions.outlookAddinOptionId,
        },
        data: {
            name: questionNames_1.QuestionNames.Capabilities,
            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.outlookAddin.title"),
            type: "singleSelect",
            staticOptions: [
                CapabilityOptions_1.OfficeAddinCapabilityOptions.outlookTaskPane(),
                CapabilityOptions_1.OfficeAddinCapabilityOptions.outlookAddinImport(),
            ],
            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createCapabilityQuestion.placeholder"),
            forgetLastValue: true,
            onDidSelection: CapabilityOptions_1.setTemplateName,
        },
        children: [
            {
                condition: {
                    equals: CapabilityOptions_1.OfficeAddinCapabilityOptions.outlookAddinImport().id,
                },
                data: { type: "group", name: questionNames_1.QuestionNames.OfficeAddinImport },
                children: [
                    {
                        data: {
                            type: "folder",
                            name: questionNames_1.QuestionNames.OfficeAddinFolder,
                            title: "Existing add-in project folder",
                        },
                    },
                    {
                        data: {
                            type: "singleFile",
                            name: questionNames_1.QuestionNames.OfficeAddinManifest,
                            title: "Select import project manifest file",
                        },
                    },
                ],
            },
        ],
    };
}
exports.outlookAddinProjectTypeNode = outlookAddinProjectTypeNode;
function wxpAddinProjectTypeNode() {
    return {
        condition: {
            equals: ProjectTypeOptions_1.ProjectTypeOptions.officeMetaOSOptionId,
        },
        data: {
            name: questionNames_1.QuestionNames.Capabilities,
            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.officeAddin.title"),
            type: "singleSelect",
            staticOptions: [
                CapabilityOptions_1.OfficeAddinCapabilityOptions.wxpTaskPane(),
                ...(featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.DAMetaOS)
                    ? [CapabilityOptions_1.OfficeAddinCapabilityOptions.DAMetaOS()]
                    : []),
                CapabilityOptions_1.OfficeAddinCapabilityOptions.officeAddinImport(),
            ],
            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createCapabilityQuestion.placeholder"),
            forgetLastValue: true,
            onDidSelection: CapabilityOptions_1.setTemplateName,
        },
        children: [
            officeDAMetaOSCapabilityNode(),
            {
                condition: {
                    equals: CapabilityOptions_1.OfficeAddinCapabilityOptions.officeAddinImport().id,
                },
                data: { type: "group", name: questionNames_1.QuestionNames.OfficeAddinImport },
                children: [
                    {
                        data: {
                            type: "folder",
                            name: questionNames_1.QuestionNames.OfficeAddinFolder,
                            title: "Existing add-in project folder",
                        },
                    },
                    {
                        data: {
                            type: "singleFile",
                            name: questionNames_1.QuestionNames.OfficeAddinManifest,
                            title: "Select import project manifest file",
                        },
                    },
                ],
            },
        ],
    };
}
exports.wxpAddinProjectTypeNode = wxpAddinProjectTypeNode;
function officeAddinProjectTypeNode() {
    if (featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.OfficeMetaOS)) {
        return wxpAddinProjectTypeNode();
    }
    else {
        return outlookAddinProjectTypeNode();
    }
}
exports.officeAddinProjectTypeNode = officeAddinProjectTypeNode;
function officeDAMetaOSCapabilityNode() {
    return {
        condition: { equals: CapabilityOptions_1.OfficeAddinCapabilityOptions.DAMetaOS().id },
        data: {
            name: questionNames_1.QuestionNames.DAMetaOSCapability,
            type: "singleSelect",
            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.DAMetaOS.capability.title"),
            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createCapabilityQuestion.placeholder"),
            staticOptions: [
                CapabilityOptions_1.DAMetaOSCapabilityOptions.newDAMetaOSProject(),
                CapabilityOptions_1.DAMetaOSCapabilityOptions.upgradeExistingProject(),
            ],
            onDidSelection: CapabilityOptions_1.setTemplateName,
        },
        children: [
            {
                condition: { equals: CapabilityOptions_1.DAMetaOSCapabilityOptions.upgradeExistingProject().id },
                data: {
                    type: "folder",
                    name: questionNames_1.QuestionNames.OfficeAddinFolder,
                    title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.DAMetaOS.capability.upgradeProject.projectFolder.title"),
                    placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.DAMetaOS.capability.upgradeProject.projectFolder.placeholder"),
                },
            },
        ],
    };
}
//# sourceMappingURL=officeAddinProjectTypeNode.js.map